

























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ILocale } from "@/@types/locale";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    ChangeDeliteButtons,
    LanguagesButtons,
    SubmitResetButtonGroop,
  },
})
export default class HotelName extends Vue {
  @Prop({ type: Object, default: null }) name!: ILocale;

  locale = this.$store.getters.getLanguages[0];
  newNames: ILocale = {};
  newName = "";

  @Watch("newName")
  updateNames(): void {
    this.newNames[this.locale] = this.newName;
  }

  @Watch("locale")
  getParams(): void {
    if (this.newNames)
      this.newName = this.newNames[this.locale]
        ? this.newNames[this.locale]
        : "";
    else this.newName = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("updateNames", { hotel_name: this.newNames });
    this.$bvModal.hide("hotel-name-modal");
  }

  onReset(): void {
    this.locale = this.$store.getters.getLanguages[0];
    this.newNames = {};
    this.newName = "";
  }

  mounted(): void {
    if (this.name) {
      this.newNames = this.name;
      this.getParams();
    }
  }
}
